

import React, { useState, } from "react";

import useAxiosPrivate from "../hooks/useAxiosPrivate.js";

import { Button, Menu, Form, InputNumber, Checkbox} from "antd";
import { ARCHIVE_THRESHOLD } from "../CONSTANTS.js";


const  AdminEmail = (props) => {



  const [view,setView] = useState("All");
  const [prevView,setPrevView] = useState("");

  const axiosPrivate = useAxiosPrivate();
  const [isSuccess,setIsSuccess] = useState(false);
  const [isLoading,setIsLoading] = useState(false);



  const successfulUpdate = () => {
    setIsLoading(false);
    setIsSuccess(true);
    setPrevView(view);
    setView("All");
  }

  const repeatAction = () => {
    setIsLoading(false);
    setView(prevView);
    setIsSuccess(false);
  }


  const sendEmail = async (e,type) => {
    console.log(type);
    const data = {
      timeframe: e.timeframe,
      endoftimeframe: e.endoftimeframe
    }
    setIsLoading(true);
    if (type===1){
      await axiosPrivate.post('/email/sendSiteNews');
    }
    else if (type===2){
      await axiosPrivate.post('/email/sendTradingOpen',data);
    }
    else if (type===3){
      await axiosPrivate.post('/email/sendTradingReminder',data);
    }

    successfulUpdate();
  }


  const handleClickAdmin = (e) => {
    //console.log("click ", e);
    console.log("handle click Admin");
    console.log(e);
    console.log(e.key);
    setIsSuccess(false);
    setView(e.key);

  };





  const componentMap = {
    "": null,
    siteNews: (
      <div>

        <div>
            <Form onFinish={e=>sendEmail(e,1)}>
                <div>Send Current (Prepared on Server) Site News Email</div>
                <Form.Item>
                <Button type='primary' htmlType="submit">Send Email</Button>
                </Form.Item>
            </Form>
        </div>
    </div>
    ),
    tradingOpen: (
      <div>
        <div>
          <Form onFinish={e=>sendEmail(e,2)}>
            <div>Send Email that Trading is Open</div>
            <Form.Item label="Timeframe" name="timeframe">
              <InputNumber min={ARCHIVE_THRESHOLD} precision={0}/>
            </Form.Item>
            <Form.Item label='End Msg'  name='endoftimeframe' valuePropName="checked" initialValue={false}>
              <Checkbox >Yes</Checkbox>
            </Form.Item>
            <Form.Item>
              <Button type='primary' htmlType="submit">Send Email</Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    ),
    weekendReminder: (
      <div>

        <div>
            <Form onFinish={e=>sendEmail(e,3)}>
                <div>Send Email Reminder</div>
                <Form.Item label="Timeframe" name="timeframe">
                  <InputNumber min={ARCHIVE_THRESHOLD} precision={0}/>
                </Form.Item>
                <Form.Item>
                <Button type='primary' htmlType="submit">Send Email</Button>
                </Form.Item>
            </Form>
        </div>
    </div>
    )
  };

  return (
      <div>
        {isSuccess && <div>{prevView} Update Successful</div>}
        {isLoading && <div>Sending request to the server...</div>}
        <Menu onClick={handleClickAdmin} mode='horizontal'>
            <Menu.Item key="siteNews" ><Button>Send Site News</Button></Menu.Item>
            <Menu.Item key="tradingOpen"><Button>Trading Open</Button></Menu.Item>
            <Menu.Item key="weekendReminder"><Button>Weekend Reminder</Button></Menu.Item>
        </Menu>



        {isSuccess && <Button onClick={repeatAction}>Repeat Action</Button>}
        {view!=="All" && <div>{view}</div>}
        {componentMap[view]}
      </div>
  );
  
}

export default AdminEmail;
